export const SESSION_ACCESS_TOKEN = 'access_token';
export const SESSION_EXPIRES_AT = 'expires_at';
export const SESSION_USER_EMAIL = 'user_email';
export const SESSION_FROM_LOCATION = 'sessionFrom';
export const SESSION_TEAM_KEY = 'selectedTeam';
export const IS_ISTA_USER = 'isIstaUser';
/** Support-only override that renders the app as a given plan. See `src/entitlements/starterPreviewOverride.ts`. */
export const STARTER_PLAN_OVERRIDE = 'nexoya_plan_preview_override';
/** Support-only override that renders the app as a different seat. See `src/Auth/rbac/rolePreviewOverride.ts`. */
export const ROLE_PREVIEW_OVERRIDE = 'nexoya_role_preview_override';
